import {Separator} from 'platform/components';
import {HStack, Text, VStack} from 'platform/foundation';
import type {DefaultLegendContentProps} from 'recharts';

import {ChartSwatch} from '../ChartSwatch/ChartSwatch';

/**
 * Legend in the shared chart look, below a separator that keeps 16 px to the chart and to the
 * legend. Pass it as `content` of a Recharts `Legend`. A series hidden with `hide` is left out,
 * the same way as a series that is not rendered.
 */
export function ChartLegendContent(props: DefaultLegendContentProps) {
  const entries = (props.payload ?? []).filter(
    (entry) => entry.type !== 'none' && entry.inactive !== true
  );

  return (
    <VStack>
      <Separator />
      <HStack spacing={4} justify="center" align="center" wrap>
        {entries.map((entry) => (
          <HStack key={String(entry.dataKey ?? entry.value)} spacing={2} align="center">
            <ChartSwatch color={entry.color} />
            <Text size="xSmall" color="secondary">
              {String(entry.value)}
            </Text>
          </HStack>
        ))}
      </HStack>
    </VStack>
  );
}
